class FormTabs {
  constructor(element) {
    this.element = element;
    this.buttons = this.element.querySelectorAll('[data-element="form-tabs-button"]');
    this.forms = this.element.querySelectorAll('[data-element="form-tabs-form"]');
  }

  init() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', this.buttonOnClick.bind(this, button));
    });
  }

  buttonOnClick(button) {
    const form = this.element.querySelector('[data-element="form-tabs-form"][data-form="' + button.dataset.form + '"]');
    this.setItemActive(button, form);
  }

  setItemActive(button, form) {
    if (button.parentNode.parentNode.classList.contains('is-active')) {
      this.removeAllItemsActive();
      return;
    }

    this.removeAllItemsActive();
    button.closest('.section-row').classList.add('section-row--form-tabs');
    button.parentNode.parentNode.classList.add('is-active');
    button.setAttribute('aria-selected', true);
    form.classList.add('is-active');
  }

  removeAllItemsActive() {
    this.buttons.forEach((button) => {
      button.closest('.section-row').classList.remove('section-row--form-tabs');
      button.parentNode.parentNode.classList.remove('is-active');
      button.setAttribute('aria-selected', false);
    });

    this.forms.forEach((form) => {
      form.classList.remove('is-active');
    });
  }
}

const formTabs = {
  init() {
    const formTabsItems = document.querySelectorAll('[data-module="form-tabs"]');

    if (formTabsItems) {
      formTabsItems.forEach((item) => {
        const formTabsItem = new FormTabs(item);
        formTabsItem.init();
      });
    }
  },
};

export default formTabs;
